import UrlHelper from "./utilities/UrlHelper";

import "core-js/es6/map";
import "core-js/es6/set";
import "core-js/es6/array";
import "raf/polyfill";
import "@babel/polyfill";

import React from "react";
import ReactDOM from "react-dom";
import { AppContainer } from "react-hot-loader";
import configureStore from './store/configureStore';

import App from "./App";
import Promise from 'bluebird';

global.Promise = Promise;
window.Promise = Promise;

import axios from "axios";
axios.defaults.headers.common["Content-Type"] = "application/json";
axios.defaults.withCredentials = true;
axios.defaults.baseURL = UrlHelper.getIdentifiApiUrl();

import "../assets/sass/styles.scss";

const store = configureStore();

ReactDOM.render(
    <AppContainer errorReporter={({ error }) => { throw error; }}>
        <App store={store} />
    </AppContainer>,
    document.getElementById("container")
);

if (module.hot) {
    module.hot.accept("./App", () => {
        const NewRoot = require("./App").default;
        ReactDOM.render(
            <AppContainer>
                <NewRoot store={store}/>
            </AppContainer>,
            document.getElementById("container")
        );
    });
}
